import type { FC } from "react";

import { Loader } from "@jti/core-components/components/Loader";
import { newrelic } from "@jti/fe-clients";

import { useCartItems } from "@checkout-v2/shared/hooks/useCartItems";

import { useProductsMappedToSummaryItems } from "../hooks";
import { ItemsSummaryView } from "../ItemsSummaryView";

export const CartItemsSummaryContainer: FC = () => {
  const { data: cartItems, isLoading, error } = useCartItems();
  const { summaryItems } = useProductsMappedToSummaryItems(cartItems);

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    newrelic.noticeError(new Error(`ItemsSummaryContainer rendering failed due to error: ${errorMessage}`));
    return null;
  }

  return <ItemsSummaryView summaryItems={summaryItems} />;
};
